// extracted by mini-css-extract-plugin
module.exports = {"promo":"da51a739f7--promo--O_nYP","promo-title":"da51a739f7--promo-title--FCUDe"};